var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"el-fade-in"}},[(_vm.settings.title)?_c('div',{staticClass:"keyreply-launcher",class:{
        effect: _vm.effect,
        'keyreply-shadow': _vm.settings.launcherShadow !== false,
        'keyreply-medium': !_vm.$device.mobile && _vm.settings.size !== 'large',
        'keyreply-large': !_vm.$device.mobile && _vm.settings.size === 'large',
      },style:(_vm.launcherLogo),attrs:{"id":"kr-launcher"},on:{"click":_vm.launcherClicked}},[_c('Badge')],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }